exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-ClockIn input[type=button][data-v-7ab3dd58] {\n  font-family: Arial,Helvetica,sans-serif;\n  font-size: 11px;\n  padding: 3px 5px;\n  background-color: #ffffef;\n}\n.reverse-red[data-v-7ab3dd58] {\n  background-color: #BF3628;\n  color: white;\n  font-size: 11px;\n  font-weight: 500;\n  margin-right: 6px;\n}\n.reverse-green[data-v-7ab3dd58] {\n  background-color: #339900;\n  color: white;\n}\n", ""]);

// exports
